// extracted by mini-css-extract-plugin
export var gridItemFocus = "figure-module--gridItemFocus--ca0ce";
export var root = "figure-module--root--f7682";